import { FiDollarSign, FiPieChart, FiVideo } from 'react-icons/fi';
import { GoogleIcon, InstagramIcon, TikTokIcon } from '../Icons';
import { IoIosTrophy, IoMdBusiness, IoMdTrendingUp } from 'react-icons/io';
import { CiPercent } from 'react-icons/ci';
import ConvergenceIcon from '../ConvergenceIcon';
import { FaRegCommentDots } from 'react-icons/fa';
import { HiShoppingBag } from 'react-icons/hi';
import PopularityIcon from '../PopularityIcon';
import PopularitySingleIcon from '../PopularitySingleIcon';
import { TbReportMoney } from 'react-icons/tb';

function MetricIcon({ metricLabel, narrow = false, ...props }) {
    switch (metricLabel) {
        case 'average monthly searches':
            return <GoogleIcon {...props} />;
        case 'market leaders':
            return <IoIosTrophy {...props} />;
        case 'average brand searches':
            return <IoMdBusiness {...props} />;
        case 'price point':
            return <FiDollarSign {...props} />;
        case 'predicted growth':
        case 'popularity predicted growth':
        case 'growth':
            return <IoMdTrendingUp {...props} />;
        case 'average weekly views':
            return <TikTokIcon {...props} />;
        case 'posts':
        case 'ig posts':
            return <FiVideo {...props} />;
        case 'average weekly likes':
            return <InstagramIcon {...props} />;
        case 'paid views':
        case 'paid views: all time':
            return <TbReportMoney {...props} />;
        case 'sentiment score':
            return <FaRegCommentDots {...props} />;
        case 'popularity convergence':
            return <ConvergenceIcon {...props} />;
        case 'TikTok shop':
        case 'TikTok shop: all time':
            return <HiShoppingBag {...props} />;
        case 'engagement':
        case 'engagement: all time':
            return <CiPercent {...props} />;
        case 'average monthly popularity':
            return narrow ? (
                <PopularitySingleIcon {...props} />
            ) : (
                <PopularityIcon {...props} />
            );
        case 'popularity share':
            return <FiPieChart {...props} />;
        default:
            return null;
    }
}

export default MetricIcon;
